<ion-text>
  <p class="font-text">
    O projeto de regularização foi aprovado pela prefeitura e publicado no diário oficial no dia
    <b>{{ notificacao?.payload?.publicadoDiarioOficialData | date: 'dd/MM/yyyy' }}</b>, e logo
    será enviado para o cartório.
  </p>
</ion-text>
